import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3017eef5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-monitor" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"first-space\" data-v-3017eef5><div class=\"container\" data-v-3017eef5><aside data-v-3017eef5><h1 class=\"theme-word\" data-v-3017eef5><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/logo2.png\" alt=\"logo\" data-v-3017eef5>八爪畅学机构端 </h1><h2 data-v-3017eef5>首个融合线下地推和线上引流的</h2><h2 data-v-3017eef5>双模式招生赋能平台。</h2><p data-v-3017eef5>40万教培机构的招生首选平台</p><div class=\"liner\" data-v-3017eef5></div><div class=\"code clearfix\" data-v-3017eef5><div class=\"fl\" data-v-3017eef5><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/appcode.jpg\" alt=\"android\" data-v-3017eef5><p data-v-3017eef5><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/android.png\" alt=\"android\" data-v-3017eef5>Android下载</p></div><div class=\"fl\" data-v-3017eef5><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/appcode.jpg\" alt=\"android\" data-v-3017eef5><p data-v-3017eef5><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/iphone.png\" alt=\"iphone\" data-v-3017eef5>iPhone下载</p></div></div></aside><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/phone2.png\" alt=\"phone\" class=\"phone\" data-v-3017eef5><div class=\"four-question\" data-v-3017eef5><h1 data-v-3017eef5><span data-v-3017eef5>八爪招生，助力机构解决4大经营痛点</span></h1><ul data-v-3017eef5><li data-v-3017eef5><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/q1.png\" data-v-3017eef5><div data-v-3017eef5><p data-v-3017eef5>SCENE</p><p data-v-3017eef5>1</p></div><span data-v-3017eef5>获客难</span></li><li data-v-3017eef5><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/q2.png\" data-v-3017eef5><div data-v-3017eef5><p data-v-3017eef5>SCENE</p><p data-v-3017eef5>2</p></div><span data-v-3017eef5>转化难</span></li><li data-v-3017eef5><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/q3.png\" data-v-3017eef5><div data-v-3017eef5><p data-v-3017eef5>SCENE</p><p data-v-3017eef5>3</p></div><span data-v-3017eef5>营销成本高</span></li><li data-v-3017eef5><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/q4.png\" data-v-3017eef5><div data-v-3017eef5><p data-v-3017eef5>SCENE</p><p data-v-3017eef5>4</p></div><span data-v-3017eef5>利润薄</span></li></ul></div></div></section>", 1)
const _hoisted_3 = { class: "second-space" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("aside", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "线下地推招生"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("7000专职业务员，1对1精准拉新；"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("3-5天招满，100%真实生源")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "移动端随时随地投放招生需求"),
    /*#__PURE__*/_createElementVNode("li", null, "24小时响应接单"),
    /*#__PURE__*/_createElementVNode("li", null, "根据效果，随时开启暂停和续招"),
    /*#__PURE__*/_createElementVNode("li", null, "按效果付费，获客成本低至几十")
  ])
], -1))
const _hoisted_6 = {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/se1.png",
  alt: "线下地推招生",
  class: "w856"
}
const _hoisted_7 = { class: "container" }
const _hoisted_8 = {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/se2.png",
  alt: "线上裂变招生",
  class: "w546"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("aside", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "线上裂变招生"),
  /*#__PURE__*/_createElementVNode("p", null, "资深运营团队，活动全案策划，老带新，生源极速裂变"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Day 1：活动策划，老师培训"),
    /*#__PURE__*/_createElementVNode("li", null, "Day 2：选定团长，裂变新生"),
    /*#__PURE__*/_createElementVNode("li", null, "Day 3：持续裂变，全面收割"),
    /*#__PURE__*/_createElementVNode("li", null, "校区提供课时坐享生源滚滚")
  ])
], -1))
const _hoisted_10 = { class: "container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("aside", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "在线营销服务"),
  /*#__PURE__*/_createElementVNode("p", null, "满足机构多种营销需求，帮助机构开源增收"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "课程服务：在线发布各类课程（体验课、正价课）"),
    /*#__PURE__*/_createElementVNode("li", null, "内容服务：短视频、校区动态、校区特色照片"),
    /*#__PURE__*/_createElementVNode("li", null, "营销服务：优惠券、拼团、秒杀、抽奖"),
    /*#__PURE__*/_createElementVNode("li", null, "增值服务：场地共享、科目共享、师资共享、生源共享")
  ])
], -1))
const _hoisted_12 = {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/se3.png",
  alt: "在线营销服务",
  class: "w728"
}
const _hoisted_13 = { class: "container" }
const _hoisted_14 = {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/se4.png",
  alt: "商城批发服务",
  class: "w777"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("aside", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "商城批发服务"),
  /*#__PURE__*/_createElementVNode("p", null, "链接优质供应链源头，提供玩家、教具教材批发服务"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "优质源头"),
    /*#__PURE__*/_createElementVNode("li", null, "品类丰富"),
    /*#__PURE__*/_createElementVNode("li", null, "1件起批"),
    /*#__PURE__*/_createElementVNode("li", null, "品质保障")
  ])
], -1))
const _hoisted_16 = { class: "container" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("aside", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "八爪会员服务"),
  /*#__PURE__*/_createElementVNode("p", null, "开启全国合伙人模式，加盟八爪会员，共享招生收益"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "招生专属优惠"),
    /*#__PURE__*/_createElementVNode("li", null, "会员推广权益"),
    /*#__PURE__*/_createElementVNode("li", null, "招生推广收益"),
    /*#__PURE__*/_createElementVNode("li", null, "佣金高达50%")
  ])
], -1))
const _hoisted_18 = {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/se5.png",
  alt: "八爪会员服务",
  class: "w857"
}
const _hoisted_19 = { class: "third-space" }
const _hoisted_20 = { class: "container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "他们都在用八爪招生", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "越来越多的机构开始用八爪招生，开拓新生源、收获了生意新增长", -1))
const _hoisted_23 = { class: "swiper" }
const _hoisted_24 = { class: "swiper-container swiper-them" }
const _hoisted_25 = { class: "swiper-wrapper" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "logo" }
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/linkbg2.png",
  class: "back"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("aside", { class: "fl" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "要招生，找八爪"),
  /*#__PURE__*/_createElementVNode("p", null, "全国7000多名业务员随时为您待命")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "back-word" }, "联系我们", -1))
const _hoisted_32 = { class: "on-mobile" }
const _hoisted_33 = { class: "product-tab" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "theme-word" }, "八爪畅学机构端", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "首个融合线下地推和线上引流的", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "双模式招生赋能平台", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "40万教培机构的招生首选平台", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/phone2.png" }, null, -1))
const _hoisted_39 = { class: "points" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "phone-product-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "八爪招生，助力机构解决4大经营痛点")
], -1))
const _hoisted_41 = { class: "container clearfix" }
const _hoisted_42 = { class: "container clearfix" }
const _hoisted_43 = { class: "advantages" }
const _hoisted_44 = { class: "ul-li" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "themselves" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "他们都在用八爪招生"),
  /*#__PURE__*/_createElementVNode("p", null, "越来越多的机构开始用八爪招生，开拓新生源、收获了生意新增长")
], -1))
const _hoisted_48 = { class: "swiper" }
const _hoisted_49 = { class: "swiper-container swiper-phone-them" }
const _hoisted_50 = { class: "swiper-wrapper" }
const _hoisted_51 = { class: "them-each" }
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "logo" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "together" }
const _hoisted_56 = { class: "container" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "要招生，找八爪", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "全国7000多名业务员随时为您待命", -1))

import { splitArrayIntoChunks } from "@/utils/tools";
import { ref,onMounted } from 'vue';
import { themList, advantageList, InstitutionalAPP } from "@/utils/global";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { key } from "../../store";
import Swiper, { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/swiper.min.css"; // 整个轮播图的样式
interface settledConfig {
    flag: boolean;
    type: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'mechanism',
  setup(__props) {

Swiper.use([Autoplay,Pagination,Navigation]);
let store = useStore(key);
const router = useRouter();

// 他们都在用八爪招生
const themList4 = ref<any>([])
themList4.value = splitArrayIntoChunks(themList.value,4)

// PC端-显示咨询弹窗
const reservationActive = ()=>{
    store.commit("reservationShow",true);
}

// PC端-机构入驻
const settledActive = (obj:settledConfig)=>{
    store.commit("settledActive",obj);
}

// 移动端-跳转路由
const targetPage = (name:string)=>{
  router.push({ name });
}

// 移动端-机构APP下载
const downloadApp = ()=>{
    window.open(InstitutionalAPP.value)
}
// 移动端-咨询弹窗
const counsellingPhoneActive = (flag:boolean)=>{
    store.commit("counsellingPhoneShow",flag);
}

onMounted(()=>{
  // PC端-他们都在用八爪招生
  new Swiper(".swiper-them", {
      loop: true, // 循环
      speed: 18000, //切换过渡速度
      autoplay: {
        delay: 1, //多少秒切换一次
        disableOnInteraction: true,
      },
      slidesPerView: "auto", //解决最后一张切换到第一张中间的空白
  });

  // 移动端-他们都在用八爪招生
  new Swiper(".swiper-phone-them", {
      loop: true, // 循环
      speed: 800,
      centeredSlides : true,
      slidesPerView:2,
  });
  
})

return (_ctx: any,_cache: any) => {
  const _directive_fadein = _resolveDirective("fadein")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
            [_directive_fadein]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
            [_directive_fadein]
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
            [_directive_fadein]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
            [_directive_fadein]
          ]),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
            [_directive_fadein]
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themList4.value, (list, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "swiper-slide",
                    key: key
                  }, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("img", {
                            src: item.picture,
                            alt: "照片"
                          }, null, 8, _hoisted_26),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("img", {
                              src: item.logo,
                              alt: "logo"
                            }, null, 8, _hoisted_28)
                          ]),
                          _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                          _createElementVNode("h3", null, _toDisplayString(item.description), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("section", { class: "fourth-space" }, [
        _createElementVNode("div", { class: "container clearfix" }, [
          _hoisted_29,
          _hoisted_30,
          _createElementVNode("aside", { class: "fl" }, [
            _hoisted_31,
            _createElementVNode("button", {
              class: "white-border-btn",
              onClick: reservationActive
            }, "预约咨询")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("ul", _hoisted_33, [
        _createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (targetPage('consumer')))
        }, "八爪畅学用户端"),
        _hoisted_34,
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (targetPage('serve')))
        }, "八爪优服")
      ]),
      _createElementVNode("div", { class: "grounds" }, [
        _hoisted_35,
        _hoisted_36,
        _hoisted_37,
        _hoisted_38,
        _createElementVNode("button", {
          class: "phone-product-btn",
          onClick: downloadApp
        }, "立即下载")
      ]),
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("ul", _hoisted_41, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['获客难','转化难'], (item, i) => {
            return _createElementVNode("li", { key: i }, [
              _createElementVNode("h3", null, "SCENE  " + _toDisplayString(i+1), 1),
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(item), 1)
              ])
            ])
          }), 64))
        ]),
        _createElementVNode("ul", _hoisted_42, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['营销成本高','利润薄'], (item, i) => {
            return _createElementVNode("li", { key: i }, [
              _createElementVNode("h3", null, "SCENE  " + _toDisplayString(i+3), 1),
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(item), 1)
              ])
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advantageList), (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "container",
            key: i
          }, [
            _createElementVNode("h1", null, _toDisplayString(item.title), 1),
            _createElementVNode("p", null, _toDisplayString(item.desc), 1),
            _createElementVNode("div", _hoisted_44, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (elem, k) => {
                return (_openBlock(), _createElementBlock("span", { key: k }, _toDisplayString(elem), 1))
              }), 128))
            ]),
            _withDirectives(_createElementVNode("img", {
              src: item.picture
            }, null, 8, _hoisted_45), [
              [_directive_fadein]
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(themList), (item, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "swiper-slide",
                  key: key
                }, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("img", {
                      src: item.picture,
                      class: "picture"
                    }, null, 8, _hoisted_52),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("img", {
                        src: item.logo,
                        alt: "logo"
                      }, null, 8, _hoisted_54)
                    ]),
                    _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                    _createElementVNode("h3", null, _toDisplayString(item.description), 1)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _hoisted_58,
          _createElementVNode("button", {
            class: "phone-product-white-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (counsellingPhoneActive(true)))
          }, "预约咨询")
        ])
      ])
    ])
  ], 64))
}
}

})